/**
 * Mode options for the Member Reward List component.
 */
export var MemberRewardListMode;
(function (MemberRewardListMode) {
    /**
     * Displays the list of rewards in a grid.
     */
    MemberRewardListMode["Grid"] = "Grid";
    /**
     * Displays the list of rewards in a scrolling carousel.
     */
    MemberRewardListMode["Carousel"] = "Carousel";
})(MemberRewardListMode || (MemberRewardListMode = {}));
